import { useCallback } from 'react';
import { useLocation } from 'react-router';
import { useClientContext } from 'client/context';
import { updateSettings } from 'ducks/settings/slices';
import { setStrategies } from 'ducks/strategies/slices';
import { useAppDispatch } from 'store/hooks';
import { parseQuery } from 'utils/queries';

import { StrategiesQuery } from './types';

const useStrategiesApi = () => {
  const { search } = useLocation();
  const dispatch = useAppDispatch();
  const { Voladeum, handleError } = useClientContext();

  const getData = useCallback(async () => {
    try {
      dispatch(updateSettings({ loading: true }));
      const { strategy_adapter_ids, strategy_status_ids, strategy_pair_ids } =
        parseQuery<StrategiesQuery>(search);

      const [voladeum_strategies] = await Promise.all([
        Voladeum.strategies.list({
          adapter_ids: strategy_adapter_ids || [],
          status_ids: strategy_status_ids || [],
          pair_ids: strategy_pair_ids || [],
        }),
      ]);

      dispatch(setStrategies(voladeum_strategies.data));
      dispatch(updateSettings({ loading: false }));
    } catch (err) {
      handleError(err);
    }
  }, [dispatch, search, Voladeum, handleError]);

  return { getData };
};

export { useStrategiesApi };
